import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CrearEmpleadoService } from '../../../services/administrador/crear-empleado.service';

@Component({
  selector: 'app-eliminar-empleado',
  templateUrl: './eliminar-empleado.component.html',
  styleUrls: ['./eliminar-empleado.component.css']
})
export class EliminarEmpleadoComponent implements OnInit {

  diccionarioModulo: any = {};
  mostrarCard = false;
  formulario: any;
  dataUsuario = { nombres: '', codEmpleado: '', empresa: { descripcion: ''}, direccion: '', dscaDepartamento: '', dscaCargo: ''};
  cedula: string = '';
  falsoPositivo: boolean;
  cedValida: boolean = true;

  constructor(private fb: FormBuilder, private _empleado: CrearEmpleadoService, private _util: UtilsService) { }

  ngOnInit() {
    this.formulario = this.fb.group({
      cedula: [''],
    });
  }

  onChangeCedula() {
    this.validateUser();
  }

  validateUser() {
     console.log(this.formulario.get('cedula').value);
    this._empleado.findEmpleadosCedula(this.formulario.get('cedula').value).subscribe((res: any) => {
      debugger
      if (res === undefined) {
        console.log('No se encontro al empleado');
        this.falsoPositivo = true;
        this.mostrarCard = false;
        this.cedula = '';
        this.cedValida = true;
        this.dataUsuario = { nombres: '', codEmpleado: '', empresa: { descripcion: ''}, direccion: '', dscaDepartamento: '', dscaCargo: ''};
      } else {
        console.log('Se ecnontro al empleado');
        this.falsoPositivo = false;
        this.dataUsuario = res;
        this.mostrarCard = true;
        this.cedValida = false;
        this.cedula = res.codEmpleado;
      }
    }, (err) => {
      this.dataUsuario = { nombres: '', codEmpleado: '', empresa: { descripcion: ''}, direccion: '', dscaDepartamento: '', dscaCargo: ''};
      this.mostrarCard = false;
      this.falsoPositivo = true;
      this.cedValida = true;
      this.cedula = '';
      console.log(err.error);
      this._util.mensajeErrorVisto(err.error.message, true, 10000);
    });
  }

  nuevo() {
    this.dataUsuario = { nombres: '', codEmpleado: '', empresa: { descripcion: ''}, direccion: '', dscaDepartamento: '', dscaCargo: ''};
    this.formulario.reset();
    this.mostrarCard = false;
    this.cedValida = true;
  }

  eliminar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea eliminar el siguiente colaborador?',
        text: '',
        action: 'Eliminar',
        funcion: this._empleado.deleteEmpleado(this.cedula),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.nuevo();
    }).catch((err) => {
      console.log(err);
    });
  }

}
